import { useLoginWithRedirect } from '@frontegg/nextjs';
import useAuthStore from '@pkg/auth/useStore';
import Sdk from '@pkg/sdk';
import AppLoading from '@/components/AppLoading';
import NotAuthenticated from '@/components/NotAuthenticated';
import NotAuthorized from '@/components/NotAuthorized';

export default function withAuth(Component, preventRoleOnly = false) {
  function WrapperComponent(props) {
    const loginWithRedirect = useLoginWithRedirect();
    const {
      me,
      organisation,
      isLoading,
      isAuthenticated,
      hasLimitedAccess,
      hasError,
    } = useAuthStore();
    const isRoleOnly = me?.is_role_only ?? true;

    if (isLoading) {
      return (
        <AppLoading
          reason="withAuth.isLoading"
          messages={['Pulling up your account...', '⚡ Almost ready to roll!']}
        />
      );
    }

    if (hasError) {
      return <NotAuthenticated />;
    }

    if (preventRoleOnly && isRoleOnly && organisation?.is_restricted) {
      return <NotAuthorized />;
    }

    if (!isAuthenticated || hasLimitedAccess) {
      const redirectPath = Sdk.fullPath();
      if (redirectPath !== '/' && redirectPath !== '/dashboard') {
        localStorage.setItem('_REDIRECT_AFTER_LOGIN_', redirectPath);
      }
      loginWithRedirect();
      return null;
    }

    return <Component {...props} />;
  }

  return WrapperComponent;
}
